import { get, post } from '../index';

// The companies the signed-in person may work in (back/routes/companyMembership).
export const getMyCompanies = () => get('/company-membership/mine');

// Make one of them active; answers with a fresh session token for it.
export const switchMyCompany = (company) => post('/company-membership/switch', { company });
